/**
 * @file Shared React component — components/Layout/SidebarUser.tsx.
 */

import React from "react";
import "./SidebarUser.css";
import SidebarFooter from "./SidebarFooter";

interface Props {
  onSelect: (value: string) => void;
  activeSection?: string;
  materialStage?: "input" | "result";
}

const SidebarUser: React.FC<Props> = ({
  onSelect,
  activeSection,
}) => {
  return (
    <div className="sidebar">
      <div className="sidebar-inner">
        <div
          className={`menu-btn ${activeSection === "Home" ? "active" : ""}`}
          onClick={() => onSelect("Home")}
        >
          Home
        </div>
        <div
          className={`menu-btn ${activeSection === "Profile" ? "active" : ""}`}
          onClick={() => onSelect("Profile")}
        >
          Profile
        </div>
        <div
          className={`menu-btn ${
            activeSection === "Material Library" ? "active" : ""
          }`}
          onClick={() => onSelect("Material Library")}
        >
          Material Library
        </div>
        <div
          className={`menu-btn ${
            activeSection === "Material Analysis" ? "active" : ""
          }`}
          onClick={() => onSelect("Material Analysis")}
        >
          Material Analysis
        </div>
      </div>
      <SidebarFooter />
    </div>
  );
};

/** React component — Sidebar User. */
export default SidebarUser;
